/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var d = null,
  e = !1,
  g = 3,
  k = -1,
  l = -1,
  m = !1,
  n = !1;
function p() {
  if (!m) {
    var a = d.expirationTime;
    n ? q() : n = !0;
    _r(t, a);
  }
}
function u() {
  var a = d,
    b = d.next;
  if (d === b) d = null;else {
    var c = d.previous;
    d = c.next = b;
    b.previous = c;
  }
  a.next = a.previous = null;
  c = a.callback;
  b = a.expirationTime;
  a = a.priorityLevel;
  var f = g,
    Q = l;
  g = a;
  l = b;
  try {
    var h = c();
  } finally {
    g = f, l = Q;
  }
  if ("function" === typeof h) if (h = {
    callback: h,
    priorityLevel: a,
    expirationTime: b,
    next: null,
    previous: null
  }, null === d) d = h.next = h.previous = h;else {
    c = null;
    a = d;
    do {
      if (a.expirationTime >= b) {
        c = a;
        break;
      }
      a = a.next;
    } while (a !== d);
    null === c ? c = d : c === d && (d = h, p());
    b = c.previous;
    b.next = c.previous = h;
    h.next = c;
    h.previous = b;
  }
}
function v() {
  if (-1 === k && null !== d && 1 === d.priorityLevel) {
    m = !0;
    try {
      do u(); while (null !== d && 1 === d.priorityLevel);
    } finally {
      m = !1, null !== d ? p() : n = !1;
    }
  }
}
function t(a) {
  m = !0;
  var b = e;
  e = a;
  try {
    if (a) for (; null !== d;) {
      var c = exports.unstable_now();
      if (d.expirationTime <= c) {
        do u(); while (null !== d && d.expirationTime <= c);
      } else break;
    } else if (null !== d) {
      do u(); while (null !== d && !w());
    }
  } finally {
    m = !1, e = b, null !== d ? p() : n = !1, v();
  }
}
var x = Date,
  y = "function" === typeof setTimeout ? setTimeout : void 0,
  z = "function" === typeof clearTimeout ? clearTimeout : void 0,
  A = "function" === typeof requestAnimationFrame ? requestAnimationFrame : void 0,
  B = "function" === typeof cancelAnimationFrame ? cancelAnimationFrame : void 0,
  C,
  D;
function E(a) {
  C = A(function (b) {
    z(D);
    a(b);
  });
  D = y(function () {
    B(C);
    a(exports.unstable_now());
  }, 100);
}
if ("object" === typeof performance && "function" === typeof performance.now) {
  var F = performance;
  exports.unstable_now = function () {
    return F.now();
  };
} else exports.unstable_now = function () {
  return x.now();
};
var _r,
  q,
  w,
  G = null;
"undefined" !== typeof window ? G = window : "undefined" !== typeof global && (G = global);
if (G && G._schedMock) {
  var H = G._schedMock;
  _r = H[0];
  q = H[1];
  w = H[2];
  exports.unstable_now = H[3];
} else if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
  var I = null,
    J = function J(a) {
      if (null !== I) try {
        I(a);
      } finally {
        I = null;
      }
    };
  _r = function r(a) {
    null !== I ? setTimeout(_r, 0, a) : (I = a, setTimeout(J, 0, !1));
  };
  q = function q() {
    I = null;
  };
  w = function w() {
    return !1;
  };
} else {
  "undefined" !== typeof console && ("function" !== typeof A && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" !== typeof B && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));
  var K = null,
    L = !1,
    M = -1,
    N = !1,
    O = !1,
    P = 0,
    R = 33,
    S = 33;
  w = function w() {
    return P <= exports.unstable_now();
  };
  var T = new MessageChannel(),
    U = T.port2;
  T.port1.onmessage = function () {
    L = !1;
    var a = K,
      b = M;
    K = null;
    M = -1;
    var c = exports.unstable_now(),
      f = !1;
    if (0 >= P - c) if (-1 !== b && b <= c) f = !0;else {
      N || (N = !0, E(_V));
      K = a;
      M = b;
      return;
    }
    if (null !== a) {
      O = !0;
      try {
        a(f);
      } finally {
        O = !1;
      }
    }
  };
  var _V = function V(a) {
    if (null !== K) {
      E(_V);
      var b = a - P + S;
      b < S && R < S ? (8 > b && (b = 8), S = b < R ? R : b) : R = b;
      P = a + S;
      L || (L = !0, U.postMessage(void 0));
    } else N = !1;
  };
  _r = function _r(a, b) {
    K = a;
    M = b;
    O || 0 > b ? U.postMessage(void 0) : N || (N = !0, E(_V));
  };
  q = function q() {
    K = null;
    L = !1;
    M = -1;
  };
}
exports.unstable_ImmediatePriority = 1;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_NormalPriority = 3;
exports.unstable_IdlePriority = 5;
exports.unstable_LowPriority = 4;
exports.unstable_runWithPriority = function (a, b) {
  switch (a) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
      break;
    default:
      a = 3;
  }
  var c = g,
    f = k;
  g = a;
  k = exports.unstable_now();
  try {
    return b();
  } finally {
    g = c, k = f, v();
  }
};
exports.unstable_next = function (a) {
  switch (g) {
    case 1:
    case 2:
    case 3:
      var b = 3;
      break;
    default:
      b = g;
  }
  var c = g,
    f = k;
  g = b;
  k = exports.unstable_now();
  try {
    return a();
  } finally {
    g = c, k = f, v();
  }
};
exports.unstable_scheduleCallback = function (a, b) {
  var c = -1 !== k ? k : exports.unstable_now();
  if ("object" === typeof b && null !== b && "number" === typeof b.timeout) b = c + b.timeout;else switch (g) {
    case 1:
      b = c + -1;
      break;
    case 2:
      b = c + 250;
      break;
    case 5:
      b = c + 1073741823;
      break;
    case 4:
      b = c + 1E4;
      break;
    default:
      b = c + 5E3;
  }
  a = {
    callback: a,
    priorityLevel: g,
    expirationTime: b,
    next: null,
    previous: null
  };
  if (null === d) d = a.next = a.previous = a, p();else {
    c = null;
    var f = d;
    do {
      if (f.expirationTime > b) {
        c = f;
        break;
      }
      f = f.next;
    } while (f !== d);
    null === c ? c = d : c === d && (d = a, p());
    b = c.previous;
    b.next = c.previous = a;
    a.next = c;
    a.previous = b;
  }
  return a;
};
exports.unstable_cancelCallback = function (a) {
  var b = a.next;
  if (null !== b) {
    if (b === a) d = null;else {
      a === d && (d = b);
      var c = a.previous;
      c.next = b;
      b.previous = c;
    }
    a.next = a.previous = null;
  }
};
exports.unstable_wrapCallback = function (a) {
  var b = g;
  return function () {
    var c = g,
      f = k;
    g = b;
    k = exports.unstable_now();
    try {
      return a.apply(this, arguments);
    } finally {
      g = c, k = f, v();
    }
  };
};
exports.unstable_getCurrentPriorityLevel = function () {
  return g;
};
exports.unstable_shouldYield = function () {
  return !e && (null !== d && d.expirationTime < l || w());
};
exports.unstable_continueExecution = function () {
  null !== d && p();
};
exports.unstable_pauseExecution = function () {};
exports.unstable_getFirstCallbackNode = function () {
  return d;
};